'use strict';

angular.module('imagetrend.components')
    .directive('hlpTrueFalse', ['Format', '$timeout', function (Format, $timeout) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',
                question: '=?',

                //attributes
                name: '@',
                id: '@?',
                classes: '@?',
                modal: '@?',
                vertical: '=?',
                isDisabled: '=?',

                //required
                isRequired: '=?',
                showRequired: '=?',
                requiredText: '@?',

                //label
                showLabel: '@?',
                topLabel: '=?',
                showColon: '=?',
                label: '@?',
                title: '@?',

                //instructions
                instructions: '@?',
                pdf: '=?'
            },
            replace: true,
            transclude: true,
            require: 'ngModel',
            templateUrl: 'templates/true-false/true-false.html',
            controller: ['$scope', '$timeout', 'Validation', function($scope, $timeout, Validation) {
                if ($scope.innerForm !== undefined) {
                    if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                        $scope.question.answer.invalid = !isEmpty($scope.innerForm[$scope.name].$error);
                    }
                }

                $scope.validate = function() {
                    if ($scope.isRequired && $scope.ngModel == null && $scope.innerForm !== undefined) {
                        $scope.innerForm[$scope.name].$setValidity('required', false);

                        Validation.validateQuestion($scope.innerForm[$scope.name], $scope.validation, $scope.ngModel);
                        if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                            $scope.question.answer.invalid = !isEmpty($scope.innerForm[$scope.name].$error);
                        }
                    }
                }

                var validationTimeout = $timeout(function () {
                    if (!$scope.requiredText) {
                        $scope.requiredText = 'Please enter a ' + Format.label(($scope.label || 'value'));
                    }
                    $scope.validate();
                }, 0);

                $scope.$on('$destroy', function () {
                    $timeout.cancel(validationTimeout);
                });
            }],
            link: function (scope, elem, attrs, ctrl) {

                //attributes
                if (!attrs.name) { attrs.name = 'true_false'; }
                if (!attrs.id) { attrs.id = attrs.name; }
                if (attrs.modal == undefined) { attrs.modal = false; }

                //label
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }

                // make string a boolean
                scope.$watch('ngModel', function(newValue, oldValue) {
                    if (newValue != null && angular.isString(newValue)) {
                        scope.ngModel = (newValue.toLowerCase() === "true" || newValue.toLowerCase() === "1");
                    }
                    if (scope.isRequired && scope.ngModel != null) {
                        scope.innerForm[scope.name].$setValidity("required", true);
                    }
                });

                scope.onChange = function (item) {
                    scope.processingChange = true;
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                    var timer = $timeout(function() {
                        if (scope.question !== undefined && scope.question.answer !== undefined) {
                            scope.question.answer.invalid = !isEmpty(scope.innerForm[scope.name].$error);
                        }
                        scope.processingChange = false;
                    }, 0);
                    scope.$on('$destroy', function () {
                        $timeout.cancel(timer);
                    });
                }

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });
                //ctrl.$viewChangeListeners.push(function () {
                //    scope.$eval(attrs.ngChange);
                //});
            }
        };
    }])

;